import React, { useState, useEffect } from "react";
import Router from "next/router";
import Layout from "@/components/layout/layout"
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";

import "@/assets/css/style.css"
import "@/assets/css/meanmenu.css"
import "@/assets/css/responsive.css"
import "@/assets/css/AdmissionBadge.css"

import AnimationProvider from "@/components/layout/animationProvider"
import type { AppProps } from "next/app"
import Head from "next/head"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Preloader from "@/components/common/Preloader";

export default function App({ Component, pageProps }: AppProps) {
  const [queryClient] = useState(() => new QueryClient());
  const [loading, setLoading] = useState(true);
  const [deactivate, setDeactivate] = useState(false);

  useEffect(() => {
    // Handling initial load
    const timer = setTimeout(() => {
      setDeactivate(true);
      setTimeout(() => setLoading(false), 500); // Match CSS transition
    }, 500);

    // Handling route changes
    const handleStart = () => {
      setLoading(true);
      setDeactivate(false);
    };

    const handleComplete = () => {
      setDeactivate(true);
      setTimeout(() => setLoading(false), 500);
    };

    Router.events.on("routeChangeStart", handleStart);
    Router.events.on("routeChangeComplete", handleComplete);
    Router.events.on("routeChangeError", handleComplete);

    return () => {
      clearTimeout(timer);
      Router.events.off("routeChangeStart", handleStart);
      Router.events.off("routeChangeComplete", handleComplete);
      Router.events.off("routeChangeError", handleComplete);
    };
  }, []);

  return (
    <>
      <Head>
        <title>Cayman Academy</title>
        <link rel="icon" href="/images/cayman_icon.svg" />
      </Head>
      {loading && <Preloader deactivate={deactivate} />}
      <Layout>
        <AnimationProvider>
          <QueryClientProvider client={queryClient}>
            <Component {...pageProps} />
          </QueryClientProvider>
        </AnimationProvider>
      </Layout>
    </>
  )
}
